import React from 'react';
import { Formik } from 'formik';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { InputField } from '../../../../components/forms/fields';
import FormWrapper from '../../../../components/forms/FormWrapper';
import { sanitizeFormValues } from '../../../../utils';
import { FormSubmitType } from '../../../../types';
import { EditFormLayout } from '../../../../ui-kit';
import { newWarehouseCategoryValidationSchema } from './validation';

type OnSubmit = FormSubmitType<StockCardCategoryFormValues>;

interface StockCardCategoryFormProps {
    onSubmit: OnSubmit;
    onClose(): void;
    onRemove?(): void;
    initialValues?: StockCardCategoryFormValues;
    buttonText: string;
    dialogName: string;
}

export interface StockCardCategoryFormValues {
    name: string;
}

const StockCardCategoryForm = ({
    onSubmit,
    initialValues,
    onClose,
    onRemove,
    buttonText,
    dialogName,
}: StockCardCategoryFormProps) => {
    const { t } = useTranslation();
    const defaultValues: StockCardCategoryFormValues = {
        name: '',
    };

    const handleSubmit = async (values: StockCardCategoryFormValues) => {
        const finalValues = sanitizeFormValues(values);
        return onSubmit(finalValues);
    };

    return (
        <EditFormLayout
            isDialogView
            title={dialogName}
            onClose={onClose}
            buttonText={t('Remove')}
            onRemove={onRemove}
        >
            <Formik
                initialValues={{ ...defaultValues, ...initialValues }}
                validationSchema={newWarehouseCategoryValidationSchema}
                onSubmit={handleSubmit}
            >
                {formikProps => (
                    <FormWrapper
                        submitText={buttonText}
                        isSubmitting={formikProps.isSubmitting}
                        isDialogView
                    >
                        <Box my={2} width="100%" display="flex" flexDirection="column">
                            <InputField<StockCardCategoryFormValues> name="name" label={t('Name')} formikProps={formikProps} required />
                        </Box>
                    </FormWrapper>
                )}
            </Formik>
        </EditFormLayout>
    );
};

export default StockCardCategoryForm;
